import React, {Fragment, useRef, useState} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import TextField from "@mui/material/TextField";
import TableContainer from "@mui/material/TableContainer";
import Grid from "@mui/material/Grid";
import {styled} from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ClearIcon from '@mui/icons-material/Clear';
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CreateIcon from "@mui/icons-material/Create";
import {v4} from "uuid";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char, s_char_coins_changes} from "../../_signals/s_char";
import updChar from "../../_sig_api/updChar";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2,
    padding: 2,
    textAlign: 'center',
    color: '#000',
}));

function Coins() {
    useSignals()
    const [open, setOpen] = useState(false)
    const orichalcumRef = useRef<HTMLInputElement | null>(null);
    const goldRef = useRef<HTMLInputElement | null>(null);
    const silverRef = useRef<HTMLInputElement | null>(null);
    const copperRef = useRef<HTMLInputElement | null>(null);
    const noteRef = useRef<HTMLInputElement | null>(null);

    const changesRow = (row) => {
        return <TableRow key={row.id}><TableCell>{row.entry}</TableCell></TableRow>
    }

    const ok = () => {
        if (!orichalcumRef.current) return
        if (!goldRef.current) return
        if (!silverRef.current) return
        if (!copperRef.current) return
        if (!noteRef.current) return

        let valid = true;
        let note = '';

        let coins_orichalcum = s_char.value.orichalcum;
        let coins_gold = s_char.value.gold;
        let coins_silver = s_char.value.silver;
        let coins_copper = s_char.value.copper;

        const orichalcum = parseInt(orichalcumRef?.current?.value);
        if (orichalcum !== 0) {
            if (orichalcum > 0) {
                coins_orichalcum += orichalcum;
                note += ' +' + orichalcum + ' Orichalcum '
            } else {
                if (coins_orichalcum >= orichalcum) {
                    coins_orichalcum -= orichalcum;
                    note += ' -' + orichalcum + ' Orichalcum '
                } else valid = false;
            }
        }

        const gold = parseInt(goldRef.current.value);
        if (gold !== 0) {
            if (gold > 0) {
                coins_gold += gold;
                note += ' +' + gold + ' Gold '
            } else {
                if (coins_gold >= gold) {
                    coins_gold -= gold;
                    note += ' -' + gold + ' Gold '
                } else valid = false;
            }
        }
        const silver = parseInt(silverRef.current.value);
        if (silver !== 0) {
            if (silver > 0) {
                coins_silver += silver;
                note += ' +' + silver + ' Silber '
            } else {
                if (coins_silver >= silver) {
                    coins_silver -= silver;
                    note += ' -' + silver + ' Silber '
                } else valid = false;
            }
        }

        const copper = parseInt(copperRef.current.value);
        if (copper !== 0) {
            if (copper > 0) {
                coins_copper += copper;
                note += ' +' + copper + ' Kupfer '
            } else {
                if (coins_copper >= copper) {
                    coins_copper -= copper;
                    note += ' -' + copper + ' Kupfer '
                } else valid = false;
            }
        }
        if (valid) {
            const additionalnote = noteRef.current.value;

            if (additionalnote !== '') note += ' ' + additionalnote;

            s_char_coins_changes.value.unshift({id: v4(), entry: note});

            updChar([
                {k:'orichalcum',v: coins_orichalcum},
                {k:'gold',v:coins_gold},
                {k:'silver',v:coins_silver},
                {k:'copper',v:coins_copper}
            ])

            orichalcumRef.current.value = '0';
            goldRef.current.value = '0';
            silverRef.current.value = '0';
            copperRef.current.value = '0';
            noteRef.current.value = '';
        }

    }

    return <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
        <h3 style={{margin: "5px"}}>Münzen</h3>
        <Fragment>
            <Grid container spacing={1}>
                <Grid item xs={2}>
                    <Item>
                        Orichalcum: {s_char.value.orichalcum}
                    </Item>
                </Grid>
                <Grid item xs={2}>
                    <Item>
                        Gold: {s_char.value.gold}
                    </Item>
                </Grid>
                <Grid item xs={2}>
                    <Item>
                        Silber: {s_char.value.silver}
                    </Item>
                </Grid>
                <Grid item xs={2}>
                    <Item>
                        Kupfer: {s_char.value.copper}
                    </Item>
                </Grid>
                <Grid item xs={4}>
                    <Button className={'btn'} id="post" onClick={() => setOpen(true)}>
                        <CreateIcon/>
                    </Button>
                </Grid>
            </Grid>
            <TableContainer style={{maxHeight: 120, marginBottom: 16, marginTop: 16}}>
                <Table stickyHeader style={{width: '100%'}}>
                    <TableBody>{s_char_coins_changes.value.map((row) => changesRow(row))}</TableBody>
                </Table>
            </TableContainer>

            <Dialog open={open}>
                <DialogContent>
                    <Item>
                        <TextField InputLabelProps={{shrink: true}}
                                   style={{marginLeft: 8, maxWidth: 80}}
                                   defaultValue={0}
                                   inputRef={orichalcumRef}
                                   variant="standard"
                                   type="number"
                                   label="Orichalcum"
                                   name="orichalcum"/>
                    </Item>
                    <Item>
                        <TextField InputLabelProps={{shrink: true}}
                                   style={{marginLeft: 8, maxWidth: 80}}
                                   defaultValue={0}
                                   inputRef={goldRef}
                                   variant="standard"
                                   type="number"
                                   label="Gold"
                                   name="gold"/>
                    </Item>
                    <Item>
                        <TextField InputLabelProps={{shrink: true}}
                                   style={{marginLeft: 8, maxWidth: 80}}
                                   defaultValue={0}
                                   inputRef={silverRef}
                                   variant="standard"
                                   type="number"
                                   label="Silber"
                                   name="silver"/>
                    </Item>
                    <Item>
                        <TextField InputLabelProps={{shrink: true}}
                                   style={{marginLeft: 8, maxWidth: 80}}
                                   defaultValue={0}
                                   inputRef={copperRef}
                                   variant="standard"
                                   type="number"
                                   label="Kupfer"
                                   name="copper"/>
                    </Item>
                    <Item>
                        <TextField InputLabelProps={{shrink: true}}
                                   style={{marginLeft: 8, width: '100%'}}
                                   defaultValue={""}
                                   inputRef={noteRef}
                                   variant="standard"
                                   label="Bemerkung"
                                   name="note"/>
                    </Item>
                </DialogContent>
                <DialogActions>
                    <Button className={'btn'} onClick={() => ok()}><CheckIcon/></Button>
                    <Button className={'btn'} onClick={() => setOpen(false)}><ClearIcon/></Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    </Paper>

}

export default Coins;
